import axios from "axios";
import { decryptRequest } from "../utils/crypt";

const BarGraphList = async (params) => {
  let token = localStorage.getItem("token");
  let { status, data } = await axios.get(
    `https://godrej.app-assertai.com:5000/DashboardGraphs/alertsBarGraph`,
    {
      params, // Query parameters
      headers: {
        authorization: `Bearer ${token}`, // Pass token in headers
      },
    }
  );
  let dataafterdecryption = await decryptRequest(data.data);
  return { status: status, data: JSON.parse(dataafterdecryption) };
};
const PieChartList = async (params) => {
  let token = localStorage.getItem("token");
  let { status, data } = await axios.get(
    `https://godrej.app-assertai.com:5000/DashboardGraphs/alertsPieChart`,
    {
      params, // Query parameters
      headers: {
        authorization: `Bearer ${token}`, // Pass token in headers
      },
    }
  );
  let dataafterdecryption = await decryptRequest(data.data);
  return { status: status, data: JSON.parse(dataafterdecryption) };
};
const Top3Location = async (params) => {
  let token = localStorage.getItem("token");
  let { data, status } = await axios.get(
    `https://godrej.app-assertai.com:5000/DashboardGraphs/topLocationBarGraph`,
    {
      params, // Query parameters
      headers: {
        authorization: `Bearer ${token}`, // Pass token in headers
      },
    }
  );
  let dataafterdecryption = await decryptRequest(data.data);
  return { status: status, data: JSON.parse(dataafterdecryption) };
};
const Top3Alert = async (params) => {
  let token = localStorage.getItem("token");
  let { data, status } = await axios.get(
    `https://godrej.app-assertai.com:5000/DashboardGraphs/topAlertsBarGraph`,
    {
      params, // Query parameters
      headers: {
        authorization: `Bearer ${token}`, // Pass token in headers
      },
    }
  );
  let dataafterdecryption = await decryptRequest(data.data);
  return { status: status, data: JSON.parse(dataafterdecryption) };
};

const BarGraphListForAlertType = async (params) => {
  let token = localStorage.getItem("token");
  let { status, data } = await axios.get(
    `https://godrej.app-assertai.com:5000/DashboardGraphs/alertsBarGraphForAlertType`,
    {
      params, // Query parameters
      headers: {
        authorization: `Bearer ${token}`, // Pass token in headers
      },
    }
  );
  let dataafterdecryption = await decryptRequest(data.data);
  return { status: status, data: JSON.parse(dataafterdecryption) };
};

export {
  BarGraphList,
  PieChartList,
  Top3Location,
  Top3Alert,
  BarGraphListForAlertType,
};
